:host {
  display: block;
  width: 272px;
}

.product-card {
  color: #fff;
  display: flex;
  width: 272px;
  height: 104px;
  background: rgba(0,0,0,0.65);
  border-radius: 8px;
  -webkit-text-decoration: none!important;
  text-decoration: none!important;
  padding: 8px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    box-sizing: border-box;
}
.product-card img.product {
  width: 88px;
    height: 88px;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -o-border-radius: 4px;
    aspect-ratio: 1;
    object-fit: cover;
    display: block;
}
.product-card-body {
  font-style: normal;
  padding-top: 2px;
  padding-bottom: 4px;
  -webkit-padding-end: 0;
  padding-inline-end: 0;
  -webkit-padding-start: 8px;
  padding-inline-start: 8px;
  text-align: left;
}
.product-card-item-name {
  font-size: 16px;
    white-space: nowrap;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 2px;
}
.product-card-item-price {
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  font-family: "Helvetica Neue","Segoe UI",Helvetica,Arial,sans-serif;
}
.ctacontainer {
  line-height: 16px;
  margin-top: 10px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  /* text-decoration: underline; */
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
}
.ctacontainer button:not(:disabled) {
  cursor: pointer;
}
.ctacontainer button {
  color: var(--as-player-btn-txt-color, #fff);
    -webkit-text-decoration: none;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
    background: var(--as-player-btn-color, #000);
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    text-align: center;
    width: 160px;
    line-height: 40px;
}
.product-buy-now-button {
  border: none;
    background: none;
    font-size: inherit;
    font-family: inherit;
    text-align: inherit;
    color: inherit;
    display: inline-block;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.buy-now-arrow {
  height: 12px;
  box-sizing: border-box;
}